export const apiZoomOut = (map) => {
  if (map) {
    map.map.zoomOut()
  }
}
